/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CrefoOutstandingOrderDto } from '../../models/crefo-outstanding-order-dto';

export interface GetOutStandingOrders$Params {
  customerGUID: string;
}

export function getOutStandingOrders(http: HttpClient, rootUrl: string, params: GetOutStandingOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CrefoOutstandingOrderDto>>> {
  const rb = new RequestBuilder(rootUrl, getOutStandingOrders.PATH, 'get');
  if (params) {
    rb.query('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CrefoOutstandingOrderDto>>;
    })
  );
}

getOutStandingOrders.PATH = '/crefo/order/outstanding';
